export const promotionConstants = {
    LOAD_PROMOTION_DETAILS: 'LOAD_PROMOTION_DETAILS',
    GET_PROMOTION_DATA: 'GET_PROMOTION_DATA',
};
